import React from "react";
import { FUEL_TYPE } from "../../constants/tariffInfo";
import { useTariff } from "../../context/TariffContext";
import EN from "../../locales/en";
import ElectricityIcon from "../ElectricityIcon";
import GasIcon from "../GasIcon";

const MonthlySpendCard = ({
  setShowHowSpendCalculatedModal,
  showEditUsageForm,
}) => {
  const {
    estimatedMonthlySpendElec,
    estimatedMonthlySpendGas,
    combinedTariffInfo,
  } = useTariff();

  const fuelType = combinedTariffInfo?.fuelType;

  return (
    <div className="border-2 border-[#afb6b9] rounded-[4px] p-4">
      <div className="flex justify-between items-start">
        <h3 className="text-md font-bold leading-[1.5]">
          {EN.energy_usage.estimated_monthly_spend_text}
        </h3>
        <button
          className="text-primary underline inline-block text-center"
          onClick={showEditUsageForm}
        >
          {EN.energy_usage.change_button_text}
        </button>
      </div>

      <div className="border-t border-[#afb6b9] mt-4 py-4 space-y-4">
        {(fuelType === FUEL_TYPE.ELEC || fuelType === FUEL_TYPE.ELECGAS) && (
          <div className="flex items-center">
            <ElectricityIcon />
            <p>
              Electricity: <strong>£{estimatedMonthlySpendElec}</strong>
            </p>
          </div>
        )}
        {(fuelType === FUEL_TYPE.GAS || fuelType === FUEL_TYPE.ELECGAS) && (
          <div className="flex items-center">
            <GasIcon />
            <p>
              Gas: <strong>£{estimatedMonthlySpendGas}</strong>
            </p>
          </div>
        )}
      </div>

      <button
        className="text-primary underline inline-block text-center"
        onClick={() => setShowHowSpendCalculatedModal(true)}
      >
        {EN.energy_usage.how_was_spend_calculated_text}
      </button>
    </div>
  );
};

export default MonthlySpendCard;
